import { GradeType } from '~/models/GradeType'

// Premium is not yet used
export type SubscriptionType = 'none' | 'trial' | 'individual' | 'basic' | 'plus' | 'premium'

export interface SubscriptionDetails {
  name: string
  ean: string
  grades: string
  type: SubscriptionType
  source?: string
  endDate?: string
  gradeTypes: GradeType[]
}

/*
 * Hardcoded list of subscriptions. Premium is not in use yet.
 * This list should cover all possible subscriptions.
 */
export const StaticSubscriptions: SubscriptionDetails[] = [
  { name: 'PrimaryTrial', ean: '9788203413285', grades: '1-7', type: 'trial', gradeTypes: [GradeType.Grade1To4, GradeType.Grade5To7] },
  { name: 'PrimaryBasic', ean: '9788203410130', grades: '1-7', type: 'basic', gradeTypes: [GradeType.Grade1To4, GradeType.Grade5To7] },
  { name: 'PrimaryIndividual', ean: '9788203339622', grades: '1-7', type: 'individual', gradeTypes: [GradeType.Grade1To4, GradeType.Grade5To7] },
  { name: 'PrimaryPlus', ean: '9788203412752', grades: '1-7', type: 'plus', gradeTypes: [GradeType.Grade1To4, GradeType.Grade5To7] },
  { name: 'PrimaryPremium', ean: '', grades: '1-7', type: 'premium', gradeTypes: [GradeType.Grade1To4, GradeType.Grade5To7] }, // Not is use yet
  { name: 'SecondaryTrial', ean: '9788203413278', grades: '8-10', type: 'trial', gradeTypes: [GradeType.Grade8To10] },
  { name: 'SecondaryBasic', ean: '9788203339769', grades: '8-10', type: 'basic', gradeTypes: [GradeType.Grade8To10] },
  { name: 'SecondaryIndividual', ean: '9788203410147', grades: '8-10', type: 'individual', gradeTypes: [GradeType.Grade8To10] },
  { name: 'SecondaryPlus', ean: '9788203412776', grades: '8-10', type: 'plus', gradeTypes: [GradeType.Grade8To10] },
  { name: 'SecondaryPremium', ean: '', grades: '8-10', type: 'premium', gradeTypes: [GradeType.Grade8To10] }, // Not is use yet
  { name: 'VgsTrial', ean: '9788203413353', grades: 'vgs', type: 'trial', gradeTypes: [GradeType.GradeVgs] },
  { name: 'VgsIndividual', ean: '9788203410321', grades: 'vgs', type: 'individual', gradeTypes: [GradeType.GradeVgs] },
]
